import * as React from 'react';
import CommentMarkersContainer from '../CommentMarkers/CommentMarkersContainer';
import SmartPlayerPlugin from './SmartPlayerPlugin';
import Constants from '../../globals/Constants';

export default ({smartPlayerInitializedPromise}: SmartPlayerCommentMarkersPluginProps) => (
      <SmartPlayerPlugin smartPlayerInitializedPromise={smartPlayerInitializedPromise}
                                 component={<CommentMarkersContainer />}
                                 pluginType={Constants.pluginType.markers}/>
);

interface SmartPlayerCommentMarkersPluginProps {
   smartPlayerInitializedPromise: any;
}
